export const durationTypes = ['Y', 'M', 'D', 'h', 'm', 's'] as const;
export type TDurationType = (typeof durationTypes)[number];

export function getDuration(
  fromDate: Date,
  toDate: Date = new Date(),
): { value: number; unit: string; type: TDurationType } {
  const duration = toDate.getTime() - fromDate.getTime();

  const seconds = Math.floor(duration / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(months / 12);

  if (years > 0) {
    return {
      type: 'Y',
      value: years,
      unit: `year${years > 1 ? 's' : ''}`,
    };
  } else if (months > 0) {
    return {
      type: 'M',
      value: months,
      unit: `month${months > 1 ? 's' : ''}`,
    };
  } else if (days > 0) {
    return {
      type: 'D',
      value: days,
      unit: `day${days > 1 ? 's' : ''}`,
    };
  } else if (hours > 0) {
    return {
      type: 'h',
      value: hours,
      unit: `hour${hours > 1 ? 's' : ''}`,
    };
  } else if (minutes > 0) {
    return {
      type: 'm',
      value: minutes,
      unit: `minute${minutes > 1 ? 's' : ''}`,
    };
  } else {
    return {
      type: 's',
      value: seconds,
      unit: `second${seconds > 1 ? 's' : ''}`,
    };
  }
}

export function getMonth(index: number) {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return monthNames[index];
}
